var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"-884.5","y":"635.8","width":"412","height":"412","key":0}),React.createElement("path",{"id":"facebook-square-icon","fill":"#f0f0f0","d":"M-884.5,635.8v412h412v-412H-884.5z M-610.8,746.4c0,0-22.9,0-32,0\r\n\tc-11.3,0-13.6,4.6-13.6,16.3c0,9.7,0,28.2,0,28.2h45.6l-4.4,49.6h-41.2v148h-59.1V841.2h-30.7V791h30.7c0,0,0-7.2,0-39.5\r\n\tc0-37.1,19.8-56.5,63.8-56.5c7.2,0,40.9,0,40.9,0V746.4z","key":1})]);
}

Facebook.defaultProps = {"version":"1.1","id":"Ebene_1","x":"0px","y":"0px","viewBox":"-935 585.8 512 512","xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
